import * as couponViewTypes from "../types/couponViewTypes";
import * as authTypes from "../types/authTypes";
import * as userTypes from "../types/userTypes";

const initialState = {
  loading: false,
  error: null,
  lastRecordedCouponId: null,
};

export default function couponViewReducer(state = initialState, action) {
  switch (action.type) {
    case couponViewTypes.RECORD_COUPON_VIEW_REQUEST:
      return { ...state, loading: true, error: null };
    case couponViewTypes.RECORD_COUPON_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        lastRecordedCouponId: action.payload?.couponPublicId || null,
      };
    case couponViewTypes.RECORD_COUPON_VIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case couponViewTypes.COUPON_VIEW_CLEAR:
    case userTypes.USER_CLEAR:
    case authTypes.LOGOUT:
      return { ...initialState };
    default:
      return state;
  }
}
